<template>
  
  <div id="app">
    <title>1111111</title>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
 /** background: linear-gradient(180deg,rgb(241, 200, 231) 0%,rgb(245, 232, 240) 100%);
  height: 100%;**/
}
</style>



// WEBPACK FOOTER //
// src/App.vue